import * as PublicApiService from "./services/PublicApiService";
import { zonedTimeToUtc, formatInTimeZone } from "date-fns-tz";
import { CURRENCY_WITHOUT_DECIMALS, isAM_PM } from "./utils/utils";
import { PROVIDER_CONFIG } from "./config/provider.config";

var countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
countries.registerLocale(require("i18n-iso-countries/langs/de.json"));
countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
countries.registerLocale(require("i18n-iso-countries/langs/it.json"));
countries.registerLocale(require("i18n-iso-countries/langs/nl.json"));

var languages = require("@cospired/i18n-iso-languages");
languages.registerLocale(require("@cospired/i18n-iso-languages/langs/en.json"));
languages.registerLocale(require("@cospired/i18n-iso-languages/langs/de.json"));
languages.registerLocale(require("@cospired/i18n-iso-languages/langs/fr.json"));
languages.registerLocale(require("@cospired/i18n-iso-languages/langs/it.json"));
languages.registerLocale(require("@cospired/i18n-iso-languages/langs/nl.json"));

const registrationModule = {
  namespaced: true,
  state: () => ({
    locale: "en",
    cannotLoad: false,
    registrationRandom:
      typeof window !== "undefined" ? window.crypto.getRandomValues(new Uint32Array(2)).join("") : "123456789",
    env: {
      stage: process.env.VUE_APP_STAGE,
      stripeReturnUrlEn: process.env.VUE_APP_STRIPE_RETURN_URL_EN,
      stripeReturnUrlDe: process.env.VUE_APP_STRIPE_RETURN_URL_DE,
      uiColor: process.env.VUE_APP_UI_COLOR,
      tenant: process.env.VUE_APP_TENANT,
      titleEn: process.env.VUE_APP_TITLE_EN,
      titleDe: process.env.VUE_APP_TITLE_DE,
      favicon: `favicon-${process.env.VUE_APP_TENANT}.ico`,
      backendUrl: `${process.env.VUE_APP_BACKEND_URL}/registration/${process.env.VUE_APP_TENANT}`,
      documentUploadUrl: `${process.env.VUE_APP_BACKEND_URL}/serviceportal/${process.env.VUE_APP_TENANT}`,
    },
    schemes: null,
    certificate: null,
    country: null,
    mode: null,
    date: null,
    time: null,
    language: null,
    syllabus: null,
    certId: null,
    requiredResources: null,
    documents: null,
    uploadResult: null,
    studentDiscount: false,
    consentDeclarationsExam: null,
    //paperCertificate: null,
    paperCertificateLegacy: true,
    paperCertificate: "donation",
    extraTime: false,
    voucherObtained: null,
    liveDates: null,
    voucherId: null,
    city: null,
    examId: null,
    noPay: false,
    paperExam: false,
    noIdCMP: false,
    timezone:
      process.env.VUE_APP_TIMEZONE_ENABLED === "true"
        ? Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Vienna"
        : "Europe/Vienna",
    examPreloaded: false,
    certPreloaded: false,
    languagePreloaded: false,
    registrationCompleted: false,
    documentUploadSuccess: false,
    documentUploadError: false,
    countryAddr: null,
    paymentMethod: null,
    certificateExpired: false,
    availableTimezones: [
      "Africa/Abidjan",
      "Africa/Accra",
      "Africa/Algiers",
      "Africa/Bissau",
      "Africa/Cairo",
      "Africa/Casablanca",
      "Africa/Ceuta",
      "Africa/El_Aaiun",
      "Africa/Johannesburg",
      "Africa/Juba",
      "Africa/Khartoum",
      "Africa/Lagos",
      "Africa/Maputo",
      "Africa/Monrovia",
      "Africa/Nairobi",
      "Africa/Ndjamena",
      "Africa/Sao_Tome",
      "Africa/Tripoli",
      "Africa/Tunis",
      "Africa/Windhoek",
      "America/Adak",
      "America/Anchorage",
      "America/Araguaina",
      "America/Argentina/Buenos_Aires",
      "America/Argentina/Catamarca",
      "America/Argentina/Cordoba",
      "America/Argentina/Jujuy",
      "America/Argentina/La_Rioja",
      "America/Argentina/Mendoza",
      "America/Argentina/Rio_Gallegos",
      "America/Argentina/Salta",
      "America/Argentina/San_Juan",
      "America/Argentina/San_Luis",
      "America/Argentina/Tucuman",
      "America/Argentina/Ushuaia",
      "America/Asuncion",
      "America/Atikokan",
      "America/Bahia",
      "America/Bahia_Banderas",
      "America/Barbados",
      "America/Belem",
      "America/Belize",
      "America/Blanc-Sablon",
      "America/Boa_Vista",
      "America/Bogota",
      "America/Boise",
      "America/Cambridge_Bay",
      "America/Campo_Grande",
      "America/Cancun",
      "America/Caracas",
      "America/Cayenne",
      "America/Chicago",
      "America/Chihuahua",
      "America/Costa_Rica",
      "America/Creston",
      "America/Cuiaba",
      "America/Curacao",
      "America/Danmarkshavn",
      "America/Dawson",
      "America/Dawson_Creek",
      "America/Denver",
      "America/Detroit",
      "America/Edmonton",
      "America/Eirunepe",
      "America/El_Salvador",
      "America/Fort_Nelson",
      "America/Fortaleza",
      "America/Glace_Bay",
      "America/Godthab",
      "America/Goose_Bay",
      "America/Grand_Turk",
      "America/Guatemala",
      "America/Guayaquil",
      "America/Guyana",
      "America/Halifax",
      "America/Havana",
      "America/Hermosillo",
      "America/Indiana/Indianapolis",
      "America/Indiana/Knox",
      "America/Indiana/Marengo",
      "America/Indiana/Petersburg",
      "America/Indiana/Tell_City",
      "America/Indiana/Vevay",
      "America/Indiana/Vincennes",
      "America/Indiana/Winamac",
      "America/Inuvik",
      "America/Iqaluit",
      "America/Jamaica",
      "America/Juneau",
      "America/Kentucky/Louisville",
      "America/Kentucky/Monticello",
      "America/La_Paz",
      "America/Lima",
      "America/Los_Angeles",
      "America/Maceio",
      "America/Managua",
      "America/Manaus",
      "America/Martinique",
      "America/Matamoros",
      "America/Mazatlan",
      "America/Menominee",
      "America/Merida",
      "America/Metlakatla",
      "America/Mexico_City",
      "America/Miquelon",
      "America/Moncton",
      "America/Monterrey",
      "America/Montevideo",
      "America/Nassau",
      "America/New_York",
      "America/Nipigon",
      "America/Nome",
      "America/Noronha",
      "America/North_Dakota/Beulah",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "America/Ojinaga",
      "America/Panama",
      "America/Pangnirtung",
      "America/Paramaribo",
      "America/Phoenix",
      "America/Port-au-Prince",
      "America/Port_of_Spain",
      "America/Porto_Velho",
      "America/Puerto_Rico",
      "America/Punta_Arenas",
      "America/Rainy_River",
      "America/Rankin_Inlet",
      "America/Recife",
      "America/Regina",
      "America/Resolute",
      "America/Rio_Branco",
      "America/Santarem",
      "America/Santiago",
      "America/Santo_Domingo",
      "America/Sao_Paulo",
      "America/Scoresbysund",
      "America/Sitka",
      "America/St_Johns",
      "America/Swift_Current",
      "America/Tegucigalpa",
      "America/Thule",
      "America/Thunder_Bay",
      "America/Tijuana",
      "America/Toronto",
      "America/Vancouver",
      "America/Whitehorse",
      "America/Winnipeg",
      "America/Yakutat",
      "America/Yellowknife",
      "Antarctica/Casey",
      "Antarctica/Davis",
      "Antarctica/DumontDUrville",
      "Antarctica/Macquarie",
      "Antarctica/Mawson",
      "Antarctica/Palmer",
      "Antarctica/Rothera",
      "Antarctica/Syowa",
      "Antarctica/Troll",
      "Antarctica/Vostok",
      "Asia/Almaty",
      "Asia/Amman",
      "Asia/Anadyr",
      "Asia/Aqtau",
      "Asia/Aqtobe",
      "Asia/Ashgabat",
      "Asia/Atyrau",
      "Asia/Baghdad",
      "Asia/Baku",
      "Asia/Bangkok",
      "Asia/Barnaul",
      "Asia/Beirut",
      "Asia/Bishkek",
      "Asia/Brunei",
      "Asia/Chita",
      "Asia/Choibalsan",
      "Asia/Colombo",
      "Asia/Damascus",
      "Asia/Dhaka",
      "Asia/Dili",
      "Asia/Dubai",
      "Asia/Dushanbe",
      "Asia/Famagusta",
      "Asia/Gaza",
      "Asia/Hebron",
      "Asia/Ho_Chi_Minh",
      "Asia/Hong_Kong",
      "Asia/Hovd",
      "Asia/Irkutsk",
      "Asia/Jakarta",
      "Asia/Jayapura",
      "Asia/Jerusalem",
      "Asia/Kabul",
      "Asia/Kamchatka",
      "Asia/Karachi",
      "Asia/Kathmandu",
      "Asia/Khandyga",
      "Asia/Kolkata",
      "Asia/Krasnoyarsk",
      "Asia/Kuala_Lumpur",
      "Asia/Kuching",
      "Asia/Macau",
      "Asia/Magadan",
      "Asia/Makassar",
      "Asia/Manila",
      "Asia/Nicosia",
      "Asia/Novokuznetsk",
      "Asia/Novosibirsk",
      "Asia/Omsk",
      "Asia/Oral",
      "Asia/Pontianak",
      "Asia/Pyongyang",
      "Asia/Qatar",
      "Asia/Qostanay",
      "Asia/Qyzylorda",
      "Asia/Riyadh",
      "Asia/Sakhalin",
      "Asia/Samarkand",
      "Asia/Seoul",
      "Asia/Shanghai",
      "Asia/Singapore",
      "Asia/Srednekolymsk",
      "Asia/Taipei",
      "Asia/Tashkent",
      "Asia/Tbilisi",
      "Asia/Tehran",
      "Asia/Thimphu",
      "Asia/Tokyo",
      "Asia/Tomsk",
      "Asia/Ulaanbaatar",
      "Asia/Urumqi",
      "Asia/Ust-Nera",
      "Asia/Vladivostok",
      "Asia/Yakutsk",
      "Asia/Yangon",
      "Asia/Yekaterinburg",
      "Asia/Yerevan",
      "Atlantic/Azores",
      "Atlantic/Bermuda",
      "Atlantic/Canary",
      "Atlantic/Cape_Verde",
      "Atlantic/Faroe",
      "Atlantic/Madeira",
      "Atlantic/Reykjavik",
      "Atlantic/South_Georgia",
      "Atlantic/Stanley",
      "Australia/Adelaide",
      "Australia/Brisbane",
      "Australia/Broken_Hill",
      "Australia/Currie",
      "Australia/Darwin",
      "Australia/Eucla",
      "Australia/Hobart",
      "Australia/Lindeman",
      "Australia/Lord_Howe",
      "Australia/Melbourne",
      "Australia/Perth",
      "Australia/Sydney",
      "Europe/Amsterdam",
      "Europe/Andorra",
      "Europe/Astrakhan",
      "Europe/Athens",
      "Europe/Belgrade",
      "Europe/Berlin",
      "Europe/Brussels",
      "Europe/Bucharest",
      "Europe/Budapest",
      "Europe/Chisinau",
      "Europe/Copenhagen",
      "Europe/Dublin",
      "Europe/Gibraltar",
      "Europe/Helsinki",
      "Europe/Istanbul",
      "Europe/Kaliningrad",
      "Europe/Kiev",
      "Europe/Kirov",
      "Europe/Lisbon",
      "Europe/London",
      "Europe/Luxembourg",
      "Europe/Madrid",
      "Europe/Malta",
      "Europe/Minsk",
      "Europe/Monaco",
      "Europe/Moscow",
      "Europe/Oslo",
      "Europe/Paris",
      "Europe/Prague",
      "Europe/Riga",
      "Europe/Rome",
      "Europe/Samara",
      "Europe/Saratov",
      "Europe/Simferopol",
      "Europe/Sofia",
      "Europe/Stockholm",
      "Europe/Tallinn",
      "Europe/Tirane",
      "Europe/Ulyanovsk",
      "Europe/Uzhgorod",
      "Europe/Vienna",
      "Europe/Vilnius",
      "Europe/Volgograd",
      "Europe/Warsaw",
      "Europe/Zaporozhye",
      "Europe/Zurich",
      "Indian/Chagos",
      "Indian/Christmas",
      "Indian/Cocos",
      "Indian/Kerguelen",
      "Indian/Mahe",
      "Indian/Maldives",
      "Indian/Mauritius",
      "Indian/Reunion",
      "Pacific/Apia",
      "Pacific/Auckland",
      "Pacific/Bougainville",
      "Pacific/Chatham",
      "Pacific/Chuuk",
      "Pacific/Easter",
      "Pacific/Efate",
      "Pacific/Enderbury",
      "Pacific/Fakaofo",
      "Pacific/Fiji",
      "Pacific/Funafuti",
      "Pacific/Galapagos",
      "Pacific/Gambier",
      "Pacific/Guadalcanal",
      "Pacific/Guam",
      "Pacific/Honolulu",
      "Pacific/Kiritimati",
      "Pacific/Kosrae",
      "Pacific/Kwajalein",
      "Pacific/Majuro",
      "Pacific/Marquesas",
      "Pacific/Nauru",
      "Pacific/Niue",
      "Pacific/Norfolk",
      "Pacific/Noumea",
      "Pacific/Pago_Pago",
      "Pacific/Palau",
      "Pacific/Pitcairn",
      "Pacific/Pohnpei",
      "Pacific/Port_Moresby",
      "Pacific/Rarotonga",
      "Pacific/Tahiti",
      "Pacific/Tarawa",
      "Pacific/Tongatapu",
      "Pacific/Wake",
      "Pacific/Wallis",
    ],
    logo: null,
    istqbSrc: false,
    personalInfo: {
      title: null,
      firstname: null,
      lastname: null,
      title2: null,
      company: null,
      address: {
        line1: null,
        line2: null,
        city: null,
        zip: null,
        country: null,
        state: null,
      },
      email: null,
      email2: null,
      phone: null,
      birthday: null,
    },
    billingInfo: {
      title: null,
      firstname: null,
      lastname: null,
      title2: null,
      company: null,
      vatId: null,
      address: {
        line1: null,
        line2: null,
        city: null,
        zip: null,
        country: null,
        state: null,
      },
      email: null,
      orderNo: null,
      dates: null,
    },
    consentAccepted: {},
    toAccept: {
      voucher100Percent: false,
      stripe: {
        accepted: false,
        links: [],
      },
    },
    nextDayEnabled: false,
    applicationAllowedUntil: null,
    trainer: null,
    trainerSettings: {},
    trainerSettingsLoading: false,
  }),
  getters: {
    voucherId: (state) => {
      return state.voucherId;
    },
    trainerSettings: (state) => {
      return state.trainerSettings;
    },
    trainer: (state) => {
      return state.trainer;
    },
    trainerSettingsLoading: (state) => {
      return state.trainerSettingsLoading;
    },
    applicationAllowedUntil: (state) => {
      return state.applicationAllowedUntil;
    },
    nextDayEnabled: (state) => {
      return state.nextDayEnabled;
    },
    registrationRandom: (state) => {
      return state.registrationRandom;
    },
    locale: (state) => {
      return state.locale;
    },
    tenant: (state) => {
      return state.env.tenant;
    },
    env: (state) => {
      return state.env;
    },
    schemes: (state) => {
      if (state.schemes) {
        let schemes = Object.entries(state.schemes)
          .sort(([, a], [, b]) => Object.keys(b.certs).length - Object.keys(a.certs).length)
          .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});

        schemes = Object.keys(schemes).reduce((p, c) => {
          if (!state.schemes[c].constraints?.hideListing) p[c] = schemes[c];
          return p;
        }, {});
        return schemes;
      }
      return null;
    },
    certificate: (state) => {
      return state.certificate;
    },
    documents: (state) => {
      return state.documents;
    },
    cannotLoad: (state) => {
      return state.cannotLoad;
    },
    uiColor: (state) => {
      return state.env.uiColor;
    },
    timezone: (state) => {
      return state.timezone;
    },
    liveDates: (state) => {
      return state.liveDates;
    },
    liveDatesAvailable: (state) => {
      if (!state.country || !state.liveDates) {
        return [];
      }
      if (state.applicationAllowedUntil) {
        return state.liveDates.filter(
          (exam) =>
            exam.country === state.country &&
            new Date(`${exam.date}T${exam.time}:00Z`).getTime() <= new Date(state.applicationAllowedUntil).getTime()
        );
      } else {
        return state.liveDates.filter((exam) => exam.country === state.country);
      }
    },
    consentDeclarationsExam: (state) => {
      return state.consentDeclarationsExam;
    },
    certificateExpired: (state) => {
      return state.certificateExpired;
    },
    documentsEmpty: (state) => {
      var empty = true;
      if (state.documents != null) {
        for (var id in state.documents) {
          if (state.documents[id] != null && state.documents[id].length > 0) {
            if (state.documents[id][0].file != null) {
              empty = false;
            }
          }
        }
      }
      return empty;
    },
    uploadResult: (state) => {
      return state.uploadResult;
    },
    documentUploadSuccess: (state) => {
      return state.documentUploadSuccess;
    },
    documentUploadError: (state) => {
      return state.documentUploadError;
    },
    country: (state) => {
      return state.country;
    },
    logo: (state) => {
      return state.logo;
    },
    requiredResources: (state) => {
      return state.requiredResources;
    },
    consentDeclarations: (state) => {
      if (typeof window !== "undefined") {
        let consentDeclarations = window.i18n.t("consentDeclarations");
        if (state.paperExam) {
          consentDeclarations = consentDeclarations.filter(
            (consentDeclaration) => consentDeclaration.paperExam === true
          );
        }
        if (state.consentDeclarationsExam) {
          consentDeclarations = consentDeclarations.concat(state.consentDeclarationsExam);
        }
        if (state.certificate?.consentDeclarations) {
          consentDeclarations = consentDeclarations.concat(
            state.certificate.consentDeclarations.filter(
              (consentDeclaration) => !consentDeclaration.locale || consentDeclaration.locale === state.locale
            )
          );
        }
        if (state.trainerSettings?.consentDeclarations) {
          consentDeclarations = consentDeclarations.concat(state.trainerSettings.consentDeclarations);
        }
        return consentDeclarations;
      } else {
        return null;
      }
    },
    consentAccepted: (state) => {
      return state.consentAccepted;
    },
    mode: (state) => {
      return state.mode;
    },
    date: (state) => {
      return state.date;
    },
    time: (state) => {
      return state.time;
    },
    noIdCMP: (state) => {
      return state.noIdCMP;
    },
    dateTimeTimezone: (state) => {
      if (state.date && state.time) {
        let datetimeUTC = zonedTimeToUtc(`${state.date}T${state.time}:00`, state.timezone).toISOString();
        return isAM_PM(state.timezone)
          ? formatInTimeZone(datetimeUTC, state.timezone, "yyyy-MM-dd hh:mm a")
          : formatInTimeZone(datetimeUTC, state.timezone, "yyyy-MM-dd HH:mm");
      }
      return null;
    },
    registrationCompleted: (state) => {
      return state.registrationCompleted;
    },
    language: (state) => {
      return state.language;
    },
    istqbSrc: (state) => {
      return state.istqbSrc;
    },
    syllabus: (state) => {
      return state.syllabus;
    },
    studentDiscount: (state) => {
      return state.studentDiscount;
    },
    paperCertificate: (state) => {
      return state.paperCertificate;
    },
    paperCertificateLegacy: (state) => {
      return state.paperCertificateLegacy;
    },
    extraTime: (state) => {
      return state.extraTime;
    },
    personalInfo: (state) => {
      return state.personalInfo;
    },
    toAccept: (state) => {
      return state.toAccept;
    },
    paymentMethod: (state) => {
      return state.paymentMethod;
    },
    city: (state) => {
      return state.city;
    },
    personalInfoAddress: (state) => {
      return state.personalInfo.address;
    },
    billingInfo: (state) => {
      return state.billingInfo;
    },
    selectedScheme: (state) => {
      return state.certificate.shortname.substr(state.certificate.shortname.indexOf(" ") + 1);
    },
    certId: (state) => {
      return state.certId;
    },
    noPay: (state) => {
      return state.noPay;
    },
    paperExam: (state) => {
      return state.paperExam;
    },
    onlyVoucher: (state) => {
      if (state.certificate?.constraints?.onlyVoucher) {
        return true;
      }
      if (state.certificate?.owner && state.schemes?.[state.certificate.owner]?.constraints?.onlyVoucher === true) {
        return true;
      }
      if (state.env.tenant === "ai") {
        return true;
      }
      if (state.examId && state.dates?.[state.examId]?.onlyVoucher) {
        return true;
      }
      return false;
    },
    selectedOwner: (state) => {
      return state.certificate.owner;
    },
    voucherObtained: (state) => {
      return state.voucherObtained;
    },
    availableTimezones: (state) => {
      return state.availableTimezones;
    },
    examId: (state) => {
      return state.examId;
    },
    examPreloaded: (state) => {
      return state.examPreloaded;
    },
    languagePreloaded: (state) => {
      return state.languagePreloaded;
    },
    certPreloaded: (state) => {
      return state.certPreloaded;
    },
    countryAddr: (state) => {
      return state.countryAddr;
    },
    regulationsUrl: (state) => {
      if (state.certificate.syllabi[state.syllabus].languages[state.language].regulations_url) {
        return state.certificate.syllabi[state.syllabus].languages[state.language].regulations_url;
      }
      return null;
    },
    availableCountriesForCertificate: (state) => {
      if (!state.certificate) {
        return;
      }
      var countriesList = Object.keys(state.certificate.countries)
        .map((code) => {
          return {
            name: getCountryName(code, state.locale),
            code: code,
          };
        })
        .sort(compareCountriesAndLanguages);
      if (state.countryAddr) {
        countriesList.push({
          name: getCountryName(state.countryAddr, state.locale),
          code: state.countryAddr,
        });
      }
      if (state.env.tenant === "cmp") {
        countriesList.sort(function (x, y) {
          return x.code === "us" ? -1 : y.code == "us" ? 1 : 0;
        });
      }
      return countriesList;
    },
    availableCountriesForBilling: (state) => {
      const allCountries = countries.getNames(state.locale, { select: "official" });
      allCountries["TW"] = countries.getName("TW", state.locale, { select: "alias" });
      let countriesList = Object.keys(allCountries)
        .map((code) => {
          return {
            name: allCountries[code],
            code: code.toLowerCase(),
          };
        })
        .sort(compareCountriesAndLanguages);
      if (state.env.tenant === "cmp") {
        countriesList.sort(function (x, y) {
          return x.code === "us" ? -1 : y.code == "us" ? 1 : 0;
        });
      }
      return countriesList;
    },
    availableLanguagesForSyllabus: (state) => {
      if (!state.certificate) {
        return;
      }
      return Object.keys(state.certificate.syllabi[state.syllabus].languages)
        .map((code) => {
          var elem = {};
          if (state.locale === "de") {
            elem["name"] = languages.getName(code, state.locale);
          } else {
            elem["name"] = languages.getName(code, state.locale);
          }
          elem["code"] = code;
          return elem;
        })
        .sort(compareCountriesAndLanguages);
    },
    certificateValidTo: (state) => {
      if (state.certificate.syllabi[state.syllabus].valid_to) {
        return state.certificate.syllabi[state.syllabus].valid_to;
      }
      return null;
    },
    certificateValidFrom: (state) => {
      if (state.certificate.syllabi[state.syllabus].valid_from) {
        return state.certificate.syllabi[state.syllabus].valid_from;
      }
      return null;
    },
    studentDiscountAvailable: (state) => {
      if (state.certificate.student_discount) {
        return state.certificate.student_discount > 0;
      }
    },
    extraTimeAvailable: (state) => {
      if (state.certificate.syllabi[state.syllabus].extra_time) {
        return state.certificate.syllabi[state.syllabus].extra_time > 0;
      }
      return false;
    },
    examDuration: (state) => {
      if (state.certificate && state.syllabus) {
        if (state.extraTime) {
          return (
            state.certificate.syllabi[state.syllabus].exam_duration +
            state.certificate.syllabi[state.syllabus].extra_time
          );
        } else {
          return state.certificate.syllabi[state.syllabus].exam_duration;
        }
      }
    },
    admissionRequiremetsNeeded: (state) => {
      if (state.certificate.admission_requirements) {
        return true;
      }
      return false;
    },
    countryName: (state) => {
      return getCountryName(state.country, state.locale);
    },
    languageName: (state) => {
      if (!state.language) {
        return null;
      }
      return languages.getName(state.language, state.locale);
    },
    provider: (state) => {
      return state.certificate.countries[state.country].provider ?? "CertibleGmbH";
    },
    providerConfig: (state, getters) => {
      return PROVIDER_CONFIG[state.env.stage][getters.provider];
    },
    calculatedPrice: (state, getters) => {
      if (!state.certificate || !state.country) {
        return null;
      }
      var price = {
        basePrice: null,
        finalPrice: null,
        studentDiscount: null,
        voucherDiscount: null,
        vat: null,
        currency: null,
        provider: null,
      };
      price["currency"] = state.certificate.countries[state.country].currency;

      // if currency is non-decimal, parse to 0 decimals, otherwise to 2
      let decimals = 2;
      if (CURRENCY_WITHOUT_DECIMALS.includes(price["currency"].toUpperCase())) {
        decimals = 0;
      }

      price["basePrice"] = parseFloat(state.certificate.countries[state.country].price.toFixed(decimals));
      price["finalPrice"] = state.certificate.countries[state.country].price;
      if (state.studentDiscount) {
        price["finalPrice"] = price["basePrice"] - state.certificate.student_discount * price["basePrice"];
        price["studentDiscount"] = state.certificate.student_discount * price["basePrice"];
        price["studentDiscount"] = parseFloat(price["studentDiscount"].toFixed(decimals));
      }
      if (state.voucherObtained) {
        if (state.certId.startsWith(state.voucherObtained.cert) || !state.voucherObtained.cert) {
          if (state.voucherObtained.discountType === "P") {
            price["voucherDiscount"] = price["finalPrice"] * (state.voucherObtained.discount / 100);
            price["finalPrice"] = price["finalPrice"] - price["finalPrice"] * (state.voucherObtained.discount / 100);
          } else {
            price["voucherDiscount"] = state.voucherObtained.discount;
            price["finalPrice"] = price["finalPrice"] - state.voucherObtained.discount;
          }
          price["voucherDiscount"] = parseFloat(price["voucherDiscount"].toFixed(decimals));
        }
      }

      // Calculate VAT according to provider settings

      // Price <= 0
      if (price["finalPrice"] <= 0) {
        return price;
      }

      // Non-EU VAT
      if (getters.providerConfig.taxSystem !== "eu") {
        price["finalPrice"] = parseFloat(price["finalPrice"].toFixed(decimals));
        return price;
      }

      // EU VAT
      if (
        state.billingInfo.company &&
        state.billingInfo.vatId &&
        state.billingInfo.address.country &&
        countryEligibleForVATDiscount(state.billingInfo.address.country)
      ) {
        // VAT FREE
        price["finalPrice"] = parseFloat(price["finalPrice"].toFixed(decimals));
      } else {
        // INCL. VAT
        price["vat"] = price["finalPrice"] * 0.2;
        price["finalPrice"] += price["vat"];
        price["vat"] = parseFloat(price["vat"].toFixed(decimals));
        price["finalPrice"] = parseFloat(price["finalPrice"].toFixed(decimals));
      }
      return price;
    },
    decimals: (state, getters) => {
      if (CURRENCY_WITHOUT_DECIMALS.includes(getters.calculatedPrice.currency.toUpperCase())) {
        return 0;
      }
      return 2;
    },
    registrationData: (state, getters) => {
      let date = state.date;
      let time = state.time;
      let datetimeUTC = "";

      if (state.date && state.time) {
        datetimeUTC = zonedTimeToUtc(`${state.date}T${state.time}:00`, state.timezone).toISOString();
        date = datetimeUTC.slice(0, 10);
        time = datetimeUTC.slice(11, 16);
      }

      let registrationData = {
        examInfo: {
          tenant: state.env.tenant,
          country: state.country,
          mode: state.mode,
          date: date,
          time: time,
          timezone: state.timezone,
          datetimeTimezone: getters.dateTimeTimezone,
          datetimeUTC: datetimeUTC,
          language: state.language,
          syllabus: state.syllabus,
          certId: state.certId,
          studentDiscount: state.studentDiscount,
          extraTime: state.extraTime,
          examId: state.examId,
          paperCertificate: state.env.tenant === "certible" ? state.paperCertificate : state.paperCertificateLegacy,
          istqbScrEntryRequested: state.istqbSrc,
          applicationAllowedUntil: state.applicationAllowedUntil,
          trainer: state.trainer,
        },
        paymentInfo: {
          price: getters.calculatedPrice,
          voucher: state.voucherId,
          provider: getters.provider,
        },
        metaInfo: {
          userInterfaceLanguage: state.locale,
          submitTimestamp: new Date().toISOString(),
          userAgent: navigator.userAgent,
          screenSize: typeof window !== "undefined" ? window.innerWidth + "x" + window.innerHeight : "",
        },
        personalInfo: state.personalInfo,
        billingInfo: state.billingInfo,
        toAccept: state.toAccept,
        consentDeclarations: getters.consentDeclarations,
        consentAccepted: state.consentAccepted,
        registrationRandom: state.registrationRandom,
        action: "create",
      };

      if (state.uploadResult && state.uploadResult.uploaded) {
        registrationData.documents = state.uploadResult.uploaded;
      }

      if (state.uploadResult && state.uploadResult.failed) {
        registrationData.failedDocuments = state.uploadResult.failed;
      }

      return registrationData;
    },
    dates: (state) => {
      return state.dates;
    },
    hideCountry: (state) => {
      if (state.certificate?.constraints?.hideCountry && state.certificate?.constraints?.defaultCountry) {
        return true;
      }
      if (
        state.certificate?.owner &&
        state.schemes?.[state.certificate.owner]?.constraints?.hideCountry &&
        state.schemes?.[state.certificate.owner]?.constraints?.defaultCountry
      ) {
        return true;
      }
      return false;
    },
    hideCertificateDeliveryOptions: (state) => {
      if (state.certificate?.constraints?.hideCertificateDeliveryOptions) {
        return true;
      }
      if (
        state.certificate?.owner &&
        state.schemes?.[state.certificate.owner]?.constraints?.hideCertificateDeliveryOptions
      ) {
        return true;
      }
      return false;
    },
    stripePaymentAvailable: (state, getters) => {
      if (getters.providerConfig?.paymentMethods?.stripe) {
        return true;
      }
      return false;
    },
    invoicePaymentAvailable: (state, getters) => {
      if (getters.providerConfig?.paymentMethods?.invoice) {
        return true;
      }
      return false;
    },
  },
  mutations: {
    setApplicationAllowedUntil(state, applicationAllowedUntil) {
      state.applicationAllowedUntil = applicationAllowedUntil;
    },
    setNoIdCMP(state, noId) {
      state.noIdCMP = noId;
    },
    setLocale(state, locale) {
      state.locale = locale;
      if (locale === "en") {
        document.title = state.env.titleEn;
      }
      if (locale === "de") {
        document.title = state.env.titleDe;
      }
    },
    setSchemes(state, schemes) {
      state.schemes = schemes;
    },
    setPaymentMethod(state, paymentMethod) {
      state.paymentMethod = paymentMethod;
    },
    setNextDayEnabled(state, nextDayEnabled) {
      state.nextDayEnabled = nextDayEnabled;
    },
    setCertificate(state, certificate) {
      state.certificate = certificate;
      if (state.schemes) {
        state.logo = state.schemes[certificate.owner].logo;
      }
      if (certificate.constraints?.hideCountry && certificate.constraints?.defaultCountry) {
        state.country = certificate.constraints.defaultCountry;
      }
      if (
        state.schemes[certificate.owner].constraints?.hideCountry &&
        state.schemes[certificate.owner].constraints?.defaultCountry
      ) {
        state.country = state.schemes[certificate.owner].constraints.defaultCountry;
      }
    },
    setCountry(state, country) {
      state.country = country;
      state.personalInfo.address.country = country;
      state.billingInfo.address.country = country;
    },
    setMode(state, mode) {
      state.mode = mode;
    },
    setDate(state, date) {
      state.date = date;
    },
    setTime(state, time) {
      state.time = time;
    },
    setRequiredResources(state, requiredResources) {
      state.requiredResources = requiredResources;
    },
    setDocuments(state, documents) {
      state.documents = documents;
    },
    setCertificateExpired(state, certificateExpired) {
      state.certificateExpired = certificateExpired;
    },
    setDocumentUploadSuccess(state, documentUploadSuccess) {
      state.documentUploadSuccess = documentUploadSuccess;
    },
    setDocumentUploadError(state, documentUploadError) {
      state.documentUploadError = documentUploadError;
    },
    setConsentAccepted(state, consentAccepted) {
      state.consentAccepted = consentAccepted;
    },
    setLogo(state, logo) {
      state.logo = logo;
    },
    setLanguage(state, language) {
      state.language = language;
    },
    setConsentDeclarationsExam(state, consentDeclarationsExam) {
      state.consentDeclarationsExam = consentDeclarationsExam;
    },
    setSyllabus(state, syllabus) {
      state.syllabus = syllabus;
    },
    setStudentDiscount(state, studentDiscount) {
      state.studentDiscount = studentDiscount;
    },
    setExtraTime(state, extraTime) {
      state.extraTime = extraTime;
    },
    setCannotLoad(state, cannotLoad) {
      state.cannotLoad = cannotLoad;
    },
    setPaperCertificate(state, paperCertificate) {
      state.paperCertificate = paperCertificate;
    },
    setPaperCertificateLegacy(state, paperCertificateLegacy) {
      state.paperCertificateLegacy = paperCertificateLegacy;
    },
    setCity(state, city) {
      state.city = city;
    },
    setPersonalInfo(state, personalInfo) {
      state.personalInfo = personalInfo;
    },
    setRegistrationCompleted(state, registrationCompleted) {
      state.registrationCompleted = registrationCompleted;
    },
    setNoPay(state, noPay) {
      state.noPay = noPay;
    },
    setPaperExam(state, paperExam) {
      state.paperExam = paperExam;
    },
    setToAccept(state, toAccept) {
      state.toAccept = toAccept;
    },
    setLiveDates(state, liveDates) {
      state.liveDates = liveDates;
    },
    setBillingInfo(state, personalInfo) {
      state.billingInfo = personalInfo;
    },
    setVoucherObtained(state, voucherObtained) {
      state.voucherObtained = voucherObtained;
    },
    setUploadResult(state, uploadResult) {
      state.uploadResult = uploadResult;
    },
    setSelectedCertId(state, certId) {
      state.certId = certId;
    },
    setIstqbSrc(state, istqbSrc) {
      state.istqbSrc = istqbSrc;
    },
    setExamId(state, examId) {
      state.examId = examId;
    },
    setTimezone(state, timezone) {
      state.timezone = timezone;
    },
    setExamPreloaded(state) {
      state.examPreloaded = true;
    },
    setLanguagePreloaded(state) {
      state.languagePreloaded = true;
    },
    setCertPreloaded(state) {
      state.certPreloaded = true;
    },
    setVoucherId(state, voucherId) {
      state.voucherId = voucherId;
    },
    setCountryAddr(state, countryAddr) {
      state.countryAddr = countryAddr;
    },
    setUploadStatus(state, info) {
      state.documents[info.id][info.index].uploadStatus = info.status;
    },
    setEnv(state, env) {
      state.env = env;
    },
    setDates(state, dates) {
      state.dates = dates;
    },
    setTrainer(state, trainer) {
      state.trainer = trainer;
    },
    setTrainerSettings(state, trainerSettings) {
      state.trainerSettings = trainerSettings;
    },
    setTrainerSettingsLoading: (state, trainerSettingsLoading) => {
      state.trainerSettingsLoading = trainerSettingsLoading;
    },
  },
  actions: {
    resetDefaults(context) {
      context.commit("setDate", null);
      context.commit("setTime", null);
      context.commit(
        "setTimezone",
        process.env.VUE_APP_TIMEZONE_ENABLED === "true"
          ? Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Vienna"
          : "Europe/Vienna"
      );
      context.commit("setConsentDeclarationsExam", null);
      context.commit("setExamId", null);
      if (context.getters.tenant === "cmp") {
        context.commit("setNoPay", true);
      } else {
        context.commit("setNoPay", false);
      }
      context.commit("setCity", null);
    },
    async loadSchemes(context) {
      const schemes = await PublicApiService.getSchemes(context.getters.tenant);
      var dates = await PublicApiService.getDates(context.getters.tenant);
      if (schemes == null) {
        context.commit("setCannotLoad", true);
      } else {
        context.commit("setSchemes", schemes);
      }
      if (dates.exams) {
        dates = dates.exams;
      }
      context.commit("setMode", window.i18n.t("online"));
      context.commit("setLiveDates", getLiveDates(dates));
      if (context.getters.tenant === "as") {
        context.commit("setCountry", "at");
      }
      if (context.getters.tenant === "cmp") {
        context.commit("setNoPay", true);
      }
    },
    updateCertificate(context, certificate) {
      context.commit("setCertificate", certificate);
    },
    updateCountry(context, country) {
      context.commit("setCountry", country);
    },
    updateLocale(context, locale) {
      context.commit("setLocale", locale);
    },
    updateUploadResult(context, uploadResult) {
      context.commit("setUploadResult", uploadResult);
    },
    updateMode(context, mode) {
      context.commit("setMode", mode);
    },
    updateDate(context, date) {
      context.commit("setDate", date);
    },
    updateTime(context, time) {
      context.commit("setTime", time);
    },
    updateLanguage(context, language) {
      context.commit("setLanguage", language);
    },
    updateLogo(context, logo) {
      context.commit("setLogo", logo);
    },
    updateRegistrationCompleted(context, registrationCompleted) {
      context.commit("setRegistrationCompleted", registrationCompleted);
    },
    updatePaperCertificate(context, paperCertificate) {
      context.commit("setPaperCertificate", paperCertificate);
    },
    updatePaperCertificateLegacy(context, paperCertificateLegacy) {
      context.commit("setPaperCertificateLegacy", paperCertificateLegacy);
    },
    updateSyllabus(context, syllabus) {
      context.commit("setSyllabus", syllabus);
    },
    updateDocuments(context, documents) {
      context.commit("setDocuments", documents);
    },
    updateDocumentUploadSuccess(context, documentUploadSuccess) {
      context.commit("setDocumentUploadSuccess", documentUploadSuccess);
    },
    updateDocumentUploadError(context, documentUploadError) {
      context.commit("setDocumentUploadError", documentUploadError);
    },
    updateStudentDiscount(context, studentDiscount) {
      context.commit("setStudentDiscount", studentDiscount);
    },
    updatePaymentMethod(context, paymentMethod) {
      context.commit("setPaymentMethod", paymentMethod);
    },
    updateSelectedCertId(context, certId) {
      context.commit("setSelectedCertId", certId);
    },
    updateExtraTime(context, extraTime) {
      context.commit("setExtraTime", extraTime);
    },
    updateNextDayEnabled(context, nextDayEnabled) {
      context.commit("setNextDayEnabled", nextDayEnabled);
    },
    updateConsentAccepted(context, consentAccepted) {
      context.commit("setConsentAccepted", consentAccepted);
    },
    updateToAccept(context, toAccept) {
      context.commit("setToAccept", toAccept);
    },
    updateBillingInfo(context, personalInfo) {
      context.commit("setBillingInfo", personalInfo);
    },
    updateCertificateExpired(context, certificateExpired) {
      context.commit("setCertificateExpired", certificateExpired);
    },
    updatePersonalInfo(context, personalInfo) {
      context.commit("setPersonalInfo", personalInfo);
    },
    updateVoucherObtained(context, voucherObtained) {
      context.commit("setVoucherObtained", voucherObtained);
    },
    updateExamId(context, examId) {
      context.commit("setExamId", examId);
    },
    updateIstqbSrc(context, istqbSrc) {
      context.commit("setIstqbSrc", istqbSrc);
    },
    updateVoucherId(context, voucherId) {
      context.commit("setVoucherId", voucherId);
    },
    updateCity(context, city) {
      context.commit("setCity", city);
    },
    updateCountryAddr(context, countryAddr) {
      context.commit("setCountryAddr", countryAddr);
    },
    updateNoPay(context, noPay) {
      context.commit("setNoPay", noPay);
    },
    updateTimezone(context, timezone) {
      context.commit("setTimezone", timezone);
    },
    updateConsentDeclarationsExam(context, consentDeclarationsExam) {
      context.commit("setConsentDeclarationsExam", consentDeclarationsExam);
    },
    updateEnv(context, env) {
      context.commit("setEnv", env);
    },
    updateRequiredResources(context, requiredResources) {
      var documents = {};
      if (requiredResources) {
        for (var type of requiredResources) {
          documents[type.id] = [
            {
              file: null,
              uploadStatus: null,
            },
          ];
        }
      }
      context.commit("setDocuments", documents);
      context.commit("setRequiredResources", requiredResources);
    },
    updateUploadStatus(context, info) {
      context.commit("setUploadStatus", info);
    },
    async loadPersonalInfo(context, id) {
      if (id === null) {
        await context.dispatch("loadSchemes");
        context.commit("setNoIdCMP", true);
        return;
      }
      let personalInfo = await PublicApiService.getPersonalData(id);
      await context.dispatch("loadSchemes");
      if (!personalInfo.id) {
        context.commit("setNoIdCMP", true);
        return;
      }
      context.commit("setSelectedCertId", personalInfo.cert);
      context.commit("setCertificate", context.getters.schemes[personalInfo.owner].certs[personalInfo.cert]);
      context.commit("setLogo", context.getters.schemes[personalInfo.owner].logo);
      context.commit(
        "setSyllabus",
        Object.keys(context.getters.schemes[personalInfo.owner].certs[personalInfo.cert].syllabi)[0]
      );
      if (personalInfo.applicationAllowedUntil) {
        context.commit("setApplicationAllowedUntil", personalInfo.applicationAllowedUntil);
      }
      if (personalInfo.trainer) {
        context.dispatch("loadTrainerSettings", personalInfo.trainer);
      }
      context.commit("setPersonalInfo", {
        title: null,
        firstname: personalInfo.firstname,
        lastname: personalInfo.lastname,
        title2: null,
        email: personalInfo.email,
        phone: personalInfo.phone,
        address: personalInfo.address,
        applicationId: personalInfo.id,
      });
    },
    async loadTrainerSettings(context, trainer) {
      context.commit("setTrainerSettingsLoading", true);
      context.commit("setTrainer", trainer);
      let trainerSettings = await PublicApiService.getTrainerSettings(context.getters.env.backendUrl, trainer);
      if (trainerSettings == null) {
        console.log("Error: could not load trainer settings");
        context.commit("setTrainerSettingsLoading", false);
        return;
      }
      context.commit("setTrainerSettings", trainerSettings);
      context.commit("setTrainerSettingsLoading", false);
    },
    async preloadExam(context, params) {
      var dates = await PublicApiService.getDates(context.getters.tenant);
      const schemes = await PublicApiService.getSchemes(context.getters.tenant);
      if (schemes == null || dates == null) {
        context.commit("setCannotLoad", true);
      }
      if (dates.exams) {
        dates = dates.exams;
      }
      context.commit("setDates", dates);
      context.commit("setSchemes", schemes);
      if (context.getters.tenant === "as") {
        context.commit("setCountry", "at");
      }
      if (context.getters.tenant === "cmp") {
        context.commit("setNoPay", true);
      }
      if (params.cert) {
        if (params.cert === "CPREFL3") {
          context.commit("setSelectedCertId", "CPREFL");
        } else {
          context.commit("setSelectedCertId", params.cert);
        }
      }
      if (params.lang) {
        context.commit("setLanguage", params.lang);
        context.commit("setLanguagePreloaded");
      }
      if (params.country) {
        context.commit("setCountry", params.country);
      }
      if (params.exam && dates[params.exam]) {
        if (dates[params.exam].consentDeclarations) {
          context.commit("setConsentDeclarationsExam", dates[params.exam].consentDeclarations);
        }
        context.commit("setNoPay", dates[params.exam].noPay);
        context.commit("setExamId", params.exam);
        if (params.cert) {
          context.commit("setCountry", dates[params.exam].country);
        }
        context.commit("setExamPreloaded");
        if (dates[params.exam].paperExam) {
          context.commit("setPaperExam", dates[params.exam].paperExam);
        }
      }
      context.commit("setMode", window.i18n.t("online"));
      if (params.country_addr) {
        context.commit("setCountryAddr", params.country_addr);
      }

      if (params.cert) {
        var certificate = null;
        if (params.cert === "CPREFL3") {
          context.commit("setCertificate", schemes["IREB"].certs["CPREFL"]);
          context.commit("setSyllabus", "3.0");
          certificate = schemes["IREB"].certs["CPREFL"];
        } else {
          for (var owner in schemes) {
            for (var certId in schemes[owner].certs) {
              if (certId === params.cert) {
                context.commit("setCertificate", schemes[owner].certs[certId]);
                certificate = schemes[owner].certs[certId];
                context.commit("setLogo", schemes[owner].logo);
                console.log(params);
                console.log("keys", Object.keys(schemes[owner].certs[certId].syllabi));
                if (params.syllabus && Object.keys(schemes[owner].certs[certId].syllabi).includes(params.syllabus)) {
                  console.log(params);
                  context.commit("setSyllabus", params.syllabus);
                } else if (schemes[owner].certs[certId].default_syllabus) {
                  context.commit("setSyllabus", schemes[owner].certs[certId].default_syllabus);
                } else {
                  context.commit("setSyllabus", Object.keys(schemes[owner].certs[certId].syllabi)[0]);
                }
              }
            }
          }
        }
        if (certificate?.requirements?.admissionRequested?.requiredResources) {
          context.dispatch("updateRequiredResources", certificate.requirements.admissionRequested.requiredResources);
        }
      }
    },
  },
};

function compareCountriesAndLanguages(a, b) {
  return a.name.localeCompare(b.name);
}

function countryEligibleForVATDiscount(code) {
  const EU_countries = [
    "CH",
    "BE",
    "BG",
    "CZ",
    "DK",
    "DE",
    "EE",
    "IE",
    "EL",
    "ES",
    "FR",
    "HR",
    "IT",
    "CY",
    "LV",
    "LT",
    "LU",
    "HU",
    "MT",
    "NL",
    "PL",
    "PT",
    "RO",
    "SI",
    "SK",
    "FI",
    "SE",
  ];

  if (EU_countries.includes(code.toUpperCase())) {
    return true;
  }
  return false;
}

function getLiveDates(dates) {
  return Object.entries(dates)
    .filter(([, value]) => value.type === "live" && value.private === false)
    .map(([, value]) => value);
}

function getCountryName(code, locale) {
  code = code.toUpperCase();
  if (code === "TW") {
    return countries.getName("TW", locale, {
      select: "alias",
    });
  } else {
    return countries.getName(code, locale, {
      select: "official",
    });
  }
}

export default registrationModule;
